import { getTimeZoneString } from "app/publicDictionaryValues";
import { MyRequestTableFilterName } from "app/sections/myRequestListSections/types";
import { IRequestListFilter, MyRequestTableFilterResponse } from "service/myRequestListService/types";

// get 90 days ago and current date
const getDate = () => {
  const date = new Date();
  const day = date.getDate();
  const current = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;

  const agoDate = new Date();
  agoDate.setDate(day - 90);
  const threeMonthsAgo = agoDate.getFullYear() + "-" + (agoDate.getMonth() + 1) + "-" + agoDate.getDate();

  return [getTimeZoneString(threeMonthsAgo), getTimeZoneString(current)];
};

const getInitFilterData = () => ({
  taskGroupNames: [],
  categoryNames: [],
  taskLabelNames: [],
  highlyRegulated: [],
  triggerProcessNames: [],
  currentProcessor: [],
  processInitiatorNames: [],
  primaryProcedureOwnerNames: [],
  procedureOwnerNames: [],
});

const getInitPayloadData = () => ({
  processInitiateDateFrom: "",
  processInitiateDateTo: "",
  processScope: 1,
  accountID: [],
  processStatus: [],
  taskId: "",
  taskLabelName: "",
  transactionId: "",
  filterFields: [],
  sortFields: [],
});

const map: Record<MyRequestTableFilterName, keyof MyRequestTableFilterResponse> = {
  TaskGroupID: "taskGroupNames",
  CategoryName: "categoryNames",
  TaskLabelName: "taskLabelNames",
  HighlyRegulated: "highlyRegulated",
  PrimaryProcedureOwnerID: "primaryProcedureOwnerNames",
  ProcedureOwnerID: "procedureOwnerNames",
  TriggerProcess: "triggerProcessNames",
  CurrentProcessor: "currentProcessor",
  ProcessInitiator: "processInitiatorNames",
};

const getFilterResult = (
  tableFilterPara: {
    filterColumn: MyRequestTableFilterName;
    filterValue: string[];
  }[],
  myRequestListFilterData: IRequestListFilter
) => {
  return tableFilterPara
    .filter((item) => {
      const totalLength = myRequestListFilterData[map[item.filterColumn]].length;
      return !(item.filterValue.length === totalLength);
    })
    .map((item) => ({
      ...item,
      filterValue: item.filterValue.flatMap((v) => v),
    }));
};

export { getDate, getInitFilterData, getInitPayloadData, getFilterResult };
